import React from 'react'
import PT from 'prop-types'
import { pathOr } from 'ramda'
import { withRouter } from 'react-router-dom'
import ImageDetailSwiper from './ImageDetailSwiper'
import { imagesProp } from '../../propTypes'
import { imagePrefix, imagePrefix89 } from '../Post/helpers'
import './ImageDetail.css'

const ImagesDetail = ({ images, location }) => {
  const is89 = location.pathname.startsWith('/89')
  const prefix = is89 ? imagePrefix89 : imagePrefix

  if (images.length === 1) {
    const src = pathOr(null, [0, 'thumbs', [1], 'name'], images)
    return (
      <img
        className="image-detail"
        src={prefix + src}
        alt=""
      />
    )
  }
  return (
    <ImageDetailSwiper images={images} is89={is89} />
  )
}

ImagesDetail.propTypes = {
  images: imagesProp.isRequired,
  location: PT.shape({
    pathname: PT.string.isRequired,
  }).isRequired,
}

export default withRouter(ImagesDetail)



// WEBPACK FOOTER //
// ./src/components/Images/ImagesDetail.js